<lib-header
    [leftActionButton]="headerType === 'default' ? 'back-button' : 'none'"
    [rightActionButton]="headerType === 'user-profile' ? 'settings' : 'none'"
    [backButtonDefaultHref]="backButtonUrl"
    [backgroundColor]="headerBackgroundColor"
    [contentColor]="headerContentColor"
    [title]="title"
    [centerTitle]="headerType === 'default'"
    (settingsButtonClick)="onSettingsClick()" />
<ion-content>
    <div class="padded-background"></div>

    <div class="overlap-content ion-padding-horizontal">
        <div class="text-center overlap-content--avatar">
            <lib-avatar-image [borderColor]="avatarBorderColor" [image]="avatarImage" class="display-inline-block" />
        </div>

        <ng-content select="top-content"></ng-content>

        <div class="flex align-items-start justify-content-space-between">
            <ion-grid>
                <ion-row>
                    @for (card of cards; track card) {
                        @switch (card.type) {
                            @case ('rating') {
                                <ion-col [size]="card?.size">
                                    <lib-profile-card title="Rating" class="card-padding-small">
                                        <p>
                                            @if (card?.value > 0) {
                                                {{ card.value | number: '1.0-1' }}
                                                <span
                                                    class="text-midsmall"
                                                    [style.--paragraph-color]="'var(--ion-color-dark-orange)'">
                                                    /5.0
                                                </span>
                                            } @else {
                                                -
                                            }
                                        </p>
                                    </lib-profile-card>
                                </ion-col>
                            }
                            @case ('posted_jobs') {
                                <ion-col [size]="card?.size">
                                    <lib-profile-card title="Posted jobs" class="card-padding-small">
                                        <p>
                                            @if (card.value) {
                                                {{ card.value }}
                                            } @else {
                                                -
                                            }
                                        </p>
                                    </lib-profile-card>
                                </ion-col>
                            }
                            @case ('confirmed_jobs') {
                                <ion-col [size]="card?.size">
                                    <lib-profile-card title="Confirmed jobs" class="card-padding-small">
                                        <p>
                                            @if (card.value) {
                                                {{ card.value }}
                                            } @else {
                                                -
                                            }
                                        </p>
                                    </lib-profile-card>
                                </ion-col>
                            }
                            @case ('attendance_rate') {
                                <ion-col [size]="card?.size">
                                    <lib-profile-card title="Attendance rate" class="card-padding-small">
                                        <p>
                                            @if (card.value || card.value === 0) {
                                                {{ card.value * 100 }}%
                                            } @else {
                                                -
                                            }
                                        </p>
                                    </lib-profile-card>
                                </ion-col>
                            }
                            @case ('call_offs_rate') {
                                <ion-col [size]="card?.size">
                                    <lib-profile-card title="Call offs rate" class="card-padding-small">
                                        <p>
                                            @if (card.value || card.value === 0) {
                                                {{ card.value * 100 }}%
                                            } @else {
                                                -
                                            }
                                        </p>
                                    </lib-profile-card>
                                </ion-col>
                            }
                            @case ('pay_per_hour') {
                                <ion-col [size]="card?.size">
                                    <lib-profile-card title="Pay / Hour" class="card-padding-small">
                                        <p>
                                            @if (card.value) {
                                                {{ card.value | currencyCustom }}/h
                                            } @else {
                                                -
                                            }
                                        </p>
                                    </lib-profile-card>
                                </ion-col>
                            }
                            @case ('job_type') {
                                <ion-col [size]="card?.size">
                                    <lib-profile-card title="Job type" class="card-padding-small">
                                        <p>
                                            @if (card.value) {
                                                @if (card.value === JOB_TYPES.ONGOING) {
                                                    One time job
                                                } @else if (card.value === JOB_TYPES.ONE_TIME) {
                                                    Ongoing job
                                                } @else {
                                                    {{ card.value }}
                                                }
                                            } @else {
                                                -
                                            }
                                        </p>
                                    </lib-profile-card>
                                </ion-col>
                            }
                        }
                    }
                </ion-row>
            </ion-grid>
        </div>

        <ng-content></ng-content>
    </div>
</ion-content>
